
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const AgentPermitsService = {

    getPermissions: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-settings-agent/${account_id}`);
    },
    
    updatePermissions: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-settings-agent`, data);
    },
    
}